// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2DdUf","calendarButtons":"ClockData_calendarButtons__2uYRf"};